<script setup>
import { useGamesStore } from '@/stores/games';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

const games = useGamesStore()
const route = useRoute()
const { getProvidersByCategory, getProvidersWithoutLive } = storeToRefs(games)

const search = ref('')

const filteredProviders = computed(() => {
  if (route.params.id) {
    // provider by category
    return getProvidersByCategory.value(route.params.id)
      .filter(p => p.nm.toLowerCase().includes(search.value.toLowerCase()))
      .sort((a, b) => a.ord - b.ord)
  } else {
    // all providers
    return getProvidersWithoutLive.value
      .filter(p => p.nm.toLowerCase().includes(search.value.toLowerCase()))
      .sort((a, b) => a.ord - b.ord)
  }
})
</script>

<template>
  <div>
    <div class="flex items-center justify-between">
      <h3 class="text-gray-300 font-bold py-2 px-4">
        {{$t('games.providers')}} 
      </h3>
      <div class="SearchInput">
        <div class="SearchInput_Icon" />
        <input
          class="SearchInput_Field"
          :placeholder="$t('app.8')"
          type="search"
          v-model="search"
        />
      </div>
    </div>

    <ul class="px-3 grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4 mt-6 space-x-1">
      <li v-for="provider in filteredProviders" 
          :key="provider._id" 
          class="flex-1 px-2 bg-neutral-600/25 rounded-lg flex items-center justify-center">
        <RouterLink :to="`/casino/provider/${provider._id}`" class="block w-[94px] flex items-center justify-center">
          <img :src="provider.img" class="h-[56px] w-full " :alt="provider.nm">
        </RouterLink> 
      </li>
    </ul>
  </div>
</template>
<style scoped>
.SearchInput {
    background-color: hsla(0,0%,100%,.1);
    border-radius: 50px;
    display: flex;
    @apply mx-3 mt-2 px-3;
}

.SearchInput_Icon {
    mask-image: url("/search.svg");
    mask-size: 18px 18px;
    mask-repeat: no-repeat;
    mask-position: center;
    min-width: 18px;
    background-color: #fff;
    z-index: 20;
    display: flex;
    flex-direction: column
}

.SearchInput_Field {
    @apply flex-1 text-sm !bg-transparent placeholder:text-white font-bold text-white py-2.5 border-0;
    @apply focus:ring-0;
}

</style>
